import { render, staticRenderFns } from "./IntelligencePreview.vue?vue&type=template&id=68e11c84&scoped=true"
import script from "./IntelligencePreview.vue?vue&type=script&lang=js"
export * from "./IntelligencePreview.vue?vue&type=script&lang=js"
import style0 from "./IntelligencePreview.vue?vue&type=style&index=0&id=68e11c84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e11c84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68e11c84')) {
      api.createRecord('68e11c84', component.options)
    } else {
      api.reload('68e11c84', component.options)
    }
    module.hot.accept("./IntelligencePreview.vue?vue&type=template&id=68e11c84&scoped=true", function () {
      api.rerender('68e11c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Intelligence/IntelligencePreview.vue"
export default component.exports